/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Colors } from "../../utils/colors";
import { TCText } from "../TCText/TCText";
import { PaymentDescription } from "../paymentDescription/PaymentDescription";
import { observer } from "mobx-react-lite";
import { usePaymentStore } from "../../stores/StoreContext";
import { formatAmount } from "../../utils/utils";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import "./PaymentDetails.css";

type props = {};

export const PaymentDetails: React.FC<props> = observer(() => {
  const paymentStore = usePaymentStore();

  return (
    <div
      style={{
        backgroundColor: Colors.greenBg,
        paddingTop: 32,
        paddingLeft: 20,
        paddingRight: 20,
        borderRadius: 20,
        marginTop: 20,
      }}>
      {paymentStore.isPlayerPricesListLoading ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <LoadingSpinner loading className="custom-spinner-color" />
        </div>
      ) : (
        <div>
          <TCText
            style={{
              fontWeight: 700,
              fontSize: 32,
              lineHeight: 1.1,
              color: Colors.green,
              textAlign: "center",
            }}
            value={`${formatAmount(paymentStore.payMyPartAmount)} USD`}
          />
          <TCText
            style={{
              fontWeight: 500,
              fontSize: 14,
              color: Colors.green,
              textAlign: "center",
            }}
            value={"Pay your Part"}
          />
        </div>
      )}
      {/* <TCText
        style={{
          fontWeight: 600,
          fontSize: 14,
          color: Colors.green,
          textAlign: "center",
          marginTop: 10,
          marginBottom: 30,
        }}
        value="Price details"
      /> */}
      {/* <PaymentDetailsBorder />
      <div style={{ height: 20 }} /> */}
      <PaymentDescription />
      <TCText
        style={{
          fontSize: 10,
          color: Colors.green,
          marginTop: 15,
          marginBottom: 10,
        }}
        value={`if other players do not pay, you will be charged additional ${formatAmount(
          paymentStore.totalAmount - paymentStore.payMyPartAmount
        )} USD`}
      />
    </div>
  );
});
